import { createContext, useContext, useEffect, useSyncExternalStore, type ReactNode } from "react";
import { AuthController } from "./authController";
const AuthContext = createContext<AuthController | null>(null);

export function AuthProvider({ controller, children }: { controller: AuthController; children: ReactNode }) {
  useEffect(() => { void controller.initialize(); }, [controller]);
  return <AuthContext.Provider value={controller}>{children}</AuthContext.Provider>;
}
export function useAuth() {
  const controller = useContext(AuthContext);
  if (!controller) throw new Error("useAuth must be used within AuthProvider");
  const state = useSyncExternalStore(controller.subscribe, controller.getSnapshot);
  return { ...state, controller };
}
